import React from "react";
import Card from "../components/Card";
import TvKanalBasPaketCard from "../components/TvKanalBasPaketCard";

export default function Tv({ isVisible, network }) {
  return (
    <div className={isVisible ? "tel-pt-tv-basepackage" : "tel-pt-tv-basepackage not-visible"}>
      <p className="tel-pt-view-description">Vill du ha vårt TV-baspaket med flera kanaler?</p>
      {network.tv_kanal_bas_paket?.length > 0 &&
        network.tv_kanal_bas_paket.map((tvPackage) => {
          if (tvPackage?.title === "Baspaket" || tvPackage?.title === "Nej tack!") {
            return <TvKanalBasPaketCard data={tvPackage} />;
          }
          return null; // If the title is not "Baspaket", return null
        })}
    </div>
  );
}
